import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ConfigProvider } from "antd";

import REQUESTS from "./api/requests";

import DashboardPage from "./layout";

import NewsPage from "./pages/news";
import Support from "./pages/support";
import Statuses from "./pages/Statuses";
import Withdraw from "./pages/withdraw";
import Settings from "./pages/settings";
import Login from "./pages/login/index";
import Blacklist from "./pages/blacklist";
import PackagePage from "./pages/packages";
import Activation from "./pages/activation";
import UserPackages from "./pages/userPackages";
import RealTimeChat from "./pages/realTimeChat";
import Dashboard from "./pages/dashboard/index";
import ReferralLinks from "./pages/referralLinks";
import PaymentHistory from "./pages/paymentHistory";
import ResetPasswordPage from "./pages/resetPassword";
import DeviceManager from "./pages/deviceManager/index";
import ReferralReseller from "./pages/referralReseller";
import ReferralEarnings from "./pages/referralEarnings";
import PrivateRoute from "./pages/privateRoute/privateRoute";

import { selectappInfo } from "./features/appInfoSlice/AppInfoSlice";
import { editTranslation } from "./features/Translation/TranslationSlice";
import { editAppInfo } from "./features/appInfoSlice/AppInfoSlice";
import { emptyContext } from "./context_empty/context_empty";
import { editwidgets } from "./features/widgets/actions";
import "./App.css";
import "./index.scss"
import { selectUser } from "./features/DataUserProfile/DataUserProfileSlise";
import "antd/dist/antd.variable.min.css";
import Coupons from "./pages/coupons";
import CONSTANTS from "./config";
import Referral from "./pages/referral/Referral";
import Reseller from "./pages/reseller/Reseller";
import Notification from "./pages/notification/Notification";
import ManageCategories from "./pages/manageCategories/ManageCategories";

import Users from "./pages/users";
import Lines from "./pages/xui.one/Lines";
import SettingsXUI from "./pages/xui.one/Settings";
import Bouquets from "./pages/xui.one/Bouquets";
import CreateAdminPage from "./pages/admins";

const customizeRenderEmpty = () => <div style={{ textAlign: "center" }}></div>;

function App() {
  const dispatch = useDispatch();

  const appInfo = useSelector(selectappInfo);

  const [empty, setEmpty] = useState(true);

  const { admin_permissions } = useSelector(selectUser);

  const getTranslations = () => {
    function collback(data) {
      dispatch(editTranslation(data));
    }

    function errorCollback(data) { }

    REQUESTS.TEXT_TRANSLATION(collback, errorCollback, { id: 1 });
  };

  ConfigProvider.config({
    theme: {
      primaryColor: CONSTANTS.APP_COLOR,
    },
  });

  const getwidgets = () => {
    const collback = (data) => {
      dispatch(editwidgets(data));
    };
    REQUESTS.WIDGETS.GET(collback);
  };

  const getAppInfo = () => {
    // setLoading(true);
    const collback = (data) => {
      dispatch(editAppInfo(data));
      getwidgets();

      const root = document.documentElement;

      root.style.setProperty("--app-color", CONSTANTS.APP_COLOR);
      root.style.setProperty("--sidebar_item_color", data.sidebar_item_color);
      root.style.setProperty("--active-color", data.sidebar_item_active_color);
      root.style.setProperty("--active-background", data.sidebar_item_active_background);
      root.style.setProperty("--logo-size", data.sidebar_logo_size);
    };

    REQUESTS.APP_INFO.GET(collback);
  };

  useEffect(() => {
    getAppInfo();
    getTranslations();
  }, []);

  return (
    <div className="app">
      <ConfigProvider renderEmpty={empty ? customizeRenderEmpty : undefined}>
        <emptyContext.Provider value={[empty, setEmpty]}>
          <Helmet>
            <title>
              {process.env.REACT_APP_APPLICATION_NAME || "XPLAYER ADMIN"}
            </title>
            <link
              rel="icon"
              href={
                appInfo?.favicon || "/assets/images/icons/favicon-32x32.png"
              }
              type="image/x-icon"
            />
          </Helmet>

          <Routes>
            <Route path="/" element={<Navigate replace to="login" />} />

            <Route path="/login" element={<Login />} />

            <Route path={"/reset_password"} element={<ResetPasswordPage />} />

            <Route
              path="/DashboardPage"
              element={
                <PrivateRoute>
                  <DashboardPage />
                </PrivateRoute>
              }
            >
              {admin_permissions && admin_permissions["dashboard"] &&
                admin_permissions["dashboard"]["Show dashboard page"] &&
                <Route index element={<Dashboard />} />}

              {admin_permissions && admin_permissions["users"] &&
                admin_permissions["users"]["Show users page"] &&
                <Route path="users" element={<Users />} />}

              {admin_permissions && admin_permissions["devices"] &&
                admin_permissions["devices"]["Show devices page"] &&
                <Route path="deviceManager" element={<DeviceManager />} />
              }

              {admin_permissions && admin_permissions["reseller"] &&
                admin_permissions["reseller"]["Show reseller/referral page"] &&
                <Route path="referral" element={<Referral />} />
              }

              {admin_permissions && admin_permissions["referral"] &&
                admin_permissions["referral"]["Withdraw request"] &&
                <Route path="referralwithdraw" element={<Withdraw />} />
              }

              {admin_permissions && admin_permissions["referral"] &&
                admin_permissions["referral"]["Statuses"] &&
                <Route path="referralStatuses" element={<Statuses />} />
              }

              {admin_permissions && admin_permissions["referral"] &&
                admin_permissions["referral"]["Earnings"] &&
                <Route path="referralEarnings" element={<ReferralEarnings />} />
              }

              {admin_permissions && admin_permissions["referral"] &&
                admin_permissions["referral"]["Links"] &&
                <Route path="referralLinks" element={<ReferralLinks />} />
              }
              {admin_permissions && admin_permissions["referral"] &&
                admin_permissions["reseller"]["Show credit packages"] &&
                <Route path="referralpackages" element={<PackagePage />} />
              }

              {admin_permissions && admin_permissions["referral"] &&
                admin_permissions["reseller"]["Show credit history"] &&
                <Route path="referralactivation" element={<Activation />} />
              }

              {admin_permissions && admin_permissions["reseller"]
                && admin_permissions["reseller"]["Show reseller/referral page"] &&
                <Route path="reseller" element={<Reseller />} />
              }

              {admin_permissions && admin_permissions["pricing"] &&
                admin_permissions["pricing"]["Show pricing page"] &&
                <Route path="userPackages" element={<UserPackages />} />
              }

              {admin_permissions && admin_permissions["blacklist"] &&
                admin_permissions["blacklist"]["Show blacklist page"] &&
                <Route path="blacklist" element={<Blacklist />} />
              }

              {admin_permissions && admin_permissions["payments"] &&
                admin_permissions["payments"]["Show payments page"] &&
                <Route path="paymentHistory" element={<PaymentHistory />} />
              }

              {admin_permissions && admin_permissions["settings"] &&
                (admin_permissions["settings"]["Show smtp"] ||
                  admin_permissions["settings"]["Show application/branding"] ||
                  admin_permissions["settings"]["Show payment settings"] ||
                  admin_permissions["settings"]["Show languages"] ||
                  admin_permissions["settings"]["Show google ima"] ||
                  admin_permissions["settings"]["Update reseller translation"] ||
                  admin_permissions["settings"]["Show google recaptcha"] ||
                  admin_permissions["settings"]["Show geo restriction"]) &&
                <Route path="settings" element={<Settings />} />
              }

              {admin_permissions && admin_permissions["news"] && admin_permissions["news"]["Show news page"] &&
                <Route path="newsPage" element={<NewsPage />} />
              }

              {admin_permissions && admin_permissions["support"] && admin_permissions["support"]["Show support page"] &&
                <Route path="support" element={<Support />} />
              }

              {admin_permissions && admin_permissions["chat"] && admin_permissions["chat"]["Show chat page"] &&
                <Route path="chat" element={<RealTimeChat />} />
              }

              {admin_permissions && admin_permissions["gift codes"] && admin_permissions["gift codes"]["Show gift codes page"] &&
                <Route path="GIFTCode" element={<Coupons />} />
              }

              {admin_permissions && admin_permissions["notification"] && admin_permissions["notification"]["Show notification page"] &&
                <Route path="notification" element={<Notification />} />
              }

              {admin_permissions && admin_permissions["manage categories"] && admin_permissions["manage categories"]["Show manage categories page"] &&
                <Route path="manage-categories" element={<ManageCategories />} />
              }

              {admin_permissions && admin_permissions["admins"] && admin_permissions["admins"]["Show admins page"] &&
                <Route path="admins" element={<CreateAdminPage />} />
              }

              {admin_permissions && admin_permissions["xui one"] && admin_permissions["xui one"]["Show lines"] &&
                <Route path="xui.one-lines" element={<Lines />} />
              }

              {admin_permissions && admin_permissions["xui one"] && admin_permissions["xui one"]["Show bouquets"] &&
                <Route path="xui.one-bouquets" element={<Bouquets />} />
              }

              {admin_permissions && admin_permissions["xui one"] && admin_permissions["xui one"]["Show settings"] &&
                <Route path="xui.one-settings" element={<SettingsXUI />} />
              }
            </Route>

            <Route
              path="*" element={<Navigate replace to="/DashboardPage" />}
            />

          </Routes>
        </emptyContext.Provider>
      </ConfigProvider>
    </div>
  );
}

export default App;
